const cacheKey = (practiceId) => `billing-practice-${practiceId}`;

export const readBillingPracticeCache = (practiceId) => {
  if (!practiceId) return null;
  try {
    const raw = sessionStorage.getItem(cacheKey(practiceId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.id ? parsed : null;
  } catch {
    return null;
  }
};

export const writeBillingPracticeCache = (practice) => {
  if (!practice?.id) return;
  try {
    sessionStorage.setItem(
      cacheKey(practice.id),
      JSON.stringify({
        id: practice.id,
        practice_name: practice.practice_name,
        billing_from_date: practice.billing_from_date,
        billing_to_date: practice.billing_to_date,
        rpm_start_date: practice.rpm_start_date,
        rpm_end_date: practice.rpm_end_date
      })
    );
  } catch {
    // ignore quota / private mode errors
  }
};
